const fetchLLMSpeakingResponse = async (
  transcriptionResult,
  examGuid,
  route,
  userData,
  ExamAttemptId,
  displayAuthenticationError,
  onToken, // callback for streamed text updates
  abortRef
) => {
  abortRef.current = new AbortController();

  try {
    const response = await fetch(`${route}/getllmresponsefromtext.webapi`, {
      headers: {
        TOKEN: userData.Token,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        content: transcriptionResult,
        examAttemptId: ExamAttemptId,
      }),
      signal: abortRef.current.signal,
    });

    if (response.status === 401) {
      displayAuthenticationError();
      throw new Error("User is no longer authenticated");
    }

    if (!response.ok || !response.body) {
      throw new Error("Error fetching LLM response");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let result = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value, { stream: true });
      const lines = chunk.split("\n");

      for (const line of lines) {
        const trimmed = line.trim();
        if (trimmed && trimmed.startsWith("data: ")) {
          const jsonStr = trimmed.slice("data: ".length);
          if (jsonStr === "[DONE]") continue;

          try {
            const parsed = JSON.parse(jsonStr);
            const content = parsed?.choices?.[0]?.delta?.content;
            if (content && onToken) {
              result += content;
              onToken(content); // send only the meaningful content
            }
          } catch (err) {
            console.error("Failed to parse SSE chunk:", err);
          }
        }
      }
    }
    return result;
  } catch (error) {
    if (error.name === "AbortError") {
      console.log("Fetch aborted");
      throw new Error("Canceled generation");
    } else {
      console.error("Error fetching LLM response:", error);
      throw error; // rethrow to handle it upstream
    }
  } finally {
    // ✅ Clean up
    if (abortRef) abortRef.current = null;
  }
};

export default fetchLLMSpeakingResponse;
